
export type PreventDeletionsMode =
    "None"
    | "PreventSinkToHubDeletions";